import React from 'react';
import { styled, InputBase, Select, MenuItem } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { theme } from '../../../../../ThemeContext/ThemeObject';

interface SimpleSelectProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  height?: string | number;
  width?: string | number;
  disabled?: boolean;
}

const SelectInput = styled(InputBase)<{ customHeight?: string | number }>(({ customHeight }) => ({
  '& .MuiInputBase-input': {
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    color: '#333333',
    border: '1px solid #DDDDDD',
    fontSize: '16px',
    padding: '6px 10px',
    margin: '0px',
    fontFamily: 'Source Sans Pro, sans-serif',
    height: customHeight || '54px',
    minHeight: customHeight || '54px',
    width: '100%',
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main
    }
  },
  '& .MuiInputBase-input:focus': {
    backgroundColor: '#ffffff',
    borderRadius: '6px'
  },
  '& .MuiSvgIcon-root': {
    color: '#AAAAAA',
    marginRight: '10px',
    transition: 'all 0.16s ease-in-out'
  }
}));

const menuItemStyle = {
  fontFamily: 'Source Sans Pro, sans-serif',
  fontSize: '16px',
  padding: '8px 16px',
  color: '#333333'
};

const SimpleSelect: React.FC<SimpleSelectProps> = ({
  id,
  value,
  onChange,
  options,
  height = '54px',
  width = '200px',
  disabled = false
}) => {
  return (
    <Select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      input={<SelectInput customHeight={height} />}
      disabled={disabled}
      sx={{
        minWidth: width,
        '& .MuiOutlinedInput-root': {
          borderRadius: '6px'
        }
      }}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 300
          }
        }
      }}
    >
      {options.map((option) => (
        <MenuItem sx={menuItemStyle} value={option.value} key={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SimpleSelect;
